import { render, staticRenderFns } from "./PhotosHeader.vue?vue&type=template&id=b8d9bfc6&scoped=true&"
import script from "./PhotosHeader.vue?vue&type=script&lang=js&"
export * from "./PhotosHeader.vue?vue&type=script&lang=js&"
import style0 from "./PhotosHeader.vue?vue&type=style&index=0&id=b8d9bfc6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8d9bfc6",
  null
  
)

export default component.exports